import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface AiAssistantState {
    showAiChat: boolean;
}

const initialState: AiAssistantState = {
    showAiChat: false,
};

const aiAssistantSlice = createSlice({
    name: 'aiAssistant',
    initialState,
    reducers: {
        toggleAiChat: (state) => {
            state.showAiChat = !state.showAiChat;
        },
        setAiChat: (state, action: PayloadAction<boolean>) => {
            state.showAiChat = action.payload;
        },
    },
});

export const aiAssistantReducer = aiAssistantSlice.reducer;

export const { toggleAiChat, setAiChat } = aiAssistantSlice.actions;

export const selectShowAiChat = (state: RootState) =>
    state.aiAssistant.showAiChat;
